import { useUserProfile } from 'src/context/userProfileContext'
import { useSessionData } from 'src/hook/useSessionData'
import { useGetUserData } from '../../hooks'
import { UserInfoSkeleton } from '../userInfoSkeleton'
import { UserInfoErrorState } from '../userInfoErrorState'
import { Avatar, AvatarWrapper, UserName, Wrapper } from './userInfo.styles'
import { AVATAR_DIMENSIONS } from './userInfo.constants'

const UserInfo = () => {
  const { user } = useSessionData()
  const { visible, userUcode = user?.ucode } = useUserProfile()
  const { isLoading, isError, data } = useGetUserData({
    ucode: userUcode,
    avatarDimensions: AVATAR_DIMENSIONS,
    enabled: visible
  })

  if (isLoading) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoSkeleton />
      </Wrapper>
    )
  }

  if (isError) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoErrorState />
      </Wrapper>
    )
  }

  return (
    <Wrapper className="_border-bottom _border-gray-200 _px-5 _pb-5">
      <div className="_d-flex _align-items-center">
        <AvatarWrapper className="_d-flex _align-items-center _flex-grow-0 _flex-shrink-0 _rounded-circle _overflow-hidden _mr-4">
          <Avatar src={data?.avatarUrl} alt={data?.name} className="_w-full _h-full" />
        </AvatarWrapper>

        <UserName className="_text-gray-900 _font-weight-bold">{data?.name}</UserName>
      </div>
    </Wrapper>
  )
}

export default UserInfo
